import { FeatureBadge } from "@components/FeatureBadge";
import Button from "@components/library/Button";
import { ArrowRightIcon } from "@heroicons/react/outline";
import React from "react";

type Detail = {
  Icon: React.FunctionComponent<React.ComponentProps<"svg">>;
  title: string;
  description: string;
};

export const WhatItIsSection = ({ details }: { details: Detail[] }) => {
  return (
    <div className="container-lg">
      <div className=" grid-3 gap-x-80 gap-y-40  pt-[108px]">
        {details.map(({ Icon, title, description }) => (
          <div key={title} className="col-span-full md:col-span-1">
            <Icon className="h-24 w-24 text-blue" />
            <h4 className="mt-16 mb-4 text-16-24 font-bold">{title}</h4>
            <span className="text-14-20 ">{description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
